import { z } from 'zod';

import { MenuPlannerStateSchema } from './MenuPlannerState';
import { MenuPlannerState } from './MenuPlannerState';

export type MenuPlannerStateDto = {
	menuPlannerId: string;
	state: MenuPlannerState;
	isChild: boolean;
	message: string | null;
};

export const MenuPlannerStateDtoSchema: z.ZodType<MenuPlannerStateDto> = z.object({
	menuPlannerId: z.string(),
	state: z.lazy(() => MenuPlannerStateSchema),
	isChild: z.boolean(),
	message: z.string().nullable(),
});
